import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProviderService } from '../../services/providers/provider.service';
import { PlanService } from '../../services/plans/plan.service';
import { PatientService } from '../../services/patients/patient.service';

var Moment = require('moment');

@Component({
  moduleId: module.id,
  selector: 'create-patient',
  templateUrl: 'create-patient.component.html',
  styleUrls: ['create-patient.component.css']
})

export class CreatePatientComponent implements OnInit{

  providers;
  selectedProviderIndex;
  selectedProvider;

  plans;
  selectedPlanIndex;
  selectedPlan;

  name;
  lastname;
  documentNumber;
  email;
  areaCode;
  phone;
  gender;
  birthDate;
  validator;

  noPlans = false;

  constructor(
    protected router: Router,
    protected providerService: ProviderService,
    protected planService:PlanService,
    protected patientService:PatientService)
  { }

  ngOnInit(): void {
    this.providerService.getAll().then((providers)=>{
      this.providers = providers;
    })
  }

  providerSelected(event): void {
    this.selectedProvider = this.providers[this.selectedProviderIndex];
    this.providerService.getPlans(this.selectedProvider.id)
    .then((plans)=>{
      this.plans = plans;
      this.noPlans = this.plans.length == 0 ? true : false;
    })
  }

  planSelected(event): void {
    this.selectedPlan = this.plans[this.selectedPlanIndex];
  }

  create(): void {

    if(this.name &&
      this.lastname &&
      this.email &&
      this.gender &&
      this.documentNumber &&
      this.birthDate &&
      this.areaCode &&
      this.validator &&
      this.phone &&
      this.selectedProvider &&
      this.selectedPlan)
    {

      var patient = {
        name: this.name+' '+this.lastname,
        email: this.email,
        gender: this.gender,
        documentNumber: this.documentNumber,
        birthDate: Moment(this.birthDate).format("DD-MM-YYYY"),
        mobilePhone: String(this.areaCode)+String(this.phone),
        provider: this.selectedProvider.id,
        validator: this.validator,
        plan: this.selectedPlan.name
      }

      if(this.selectedPlan)
        patient['plan'] = this.selectedPlan.name

      this.patientService.create(patient).then((patient)=>{
        alert("¡Paciente creado con exito!");
        window.location.reload();
      }).catch((err)=>{
        alert(err);
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/patients/create/create-patient.component.ts